export default __webpack_public_path__ + "static/media/rombo.d31380ad.svg";